import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

const Counter = ({ to, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val.toLocaleString("it-IT")}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  const { t } = useLang();
  return (
    <section data-testid="stats" className="relative bg-[#1A1A1A] text-[#FAFAF7] py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <p className="text-sm tracking-luxe uppercase text-[#8B7355] mb-12 text-center">{t.stats.kicker}</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
          {t.stats.items.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="text-center"
            >
              <div className="font-display font-light text-5xl md:text-7xl text-[#FAFAF7]">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <p className="mt-3 text-xs md:text-sm tracking-wide uppercase text-white/50">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
